'use strict';

var React = require('react'),
    createStoreMixin = require('../mixins/createStoreMixin'),
    StampStore = require('../stores/StampStore'),
    ZineStore = require('../stores/ZineStore'),
    ZinePendingStampStore = require('../stores/ZinePendingStampStore'),
    StampActionCreators = require('../actions/StampActionCreators'),
    Group = require('../organisms/Group'),
    SidebarBody = require('../organisms/SidebarBody'),
    EmptyState = require('../molecules/EmptyState'),
    PureRenderMixin = require('../mixins/PureRenderMixin'),
    { PropTypes } = React;

var ZinePendingStamps = React.createClass({
  mixins: [createStoreMixin(ZinePendingStampStore, StampStore), PureRenderMixin],

  propTypes: {
    zineSlug: PropTypes.string.isRequired
  },

  getStateFromStores(props) {
    var zine = ZineStore.get(props.zineSlug),
        pendingStamps = ZinePendingStampStore.getStamps(props.zineSlug);

    return {
      zine: zine,
      pendingStamps: pendingStamps
    };
  },

  componentDidMount() {
    var zineSlug = this.props.zineSlug;
    StampActionCreators.requestZinePendingPage(zineSlug, true);
  },

  render() {
    var zineSlug = this.props.zineSlug,
        pendingStamps = this.state.pendingStamps;

    return (
      <SidebarBody title='Pending Submissions'
                   subtitle='Accept or decline stamps submitted by other users.'>
        <Group type='stamps'
               context='Sidebar'
               mode='grid'
               columns={2}
               isExpectingPage={ZinePendingStampStore.isExpectingPage(zineSlug)}
               isLastPage={ZinePendingStampStore.isLastPage(zineSlug)}
               isInvalidated={ZinePendingStampStore.isInvalidated(zineSlug)}
               loadNextPage={this.requestNextPendingPage}
               items={pendingStamps}
               itemProps={{
                size: 'small',
                routeName: 'zinePendingStamp',
                showZine: false,
                routeParams: {
                  zineSlug: zineSlug
                }
              }}>
          <EmptyState label='You have no pending submissions.'
                      context='Sidebar'
                      absoluteCenter />
        </Group>
      </SidebarBody>
    );
  },

  requestNextLatestPage() {
    var zineSlug = this.props.zineSlug;
    StampActionCreators.requestZinePendingPage(zineSlug);
  }
});

module.exports = ZinePendingStamps;



/** WEBPACK FOOTER **
 ** ./sidebar/ZinePendingStamps.jsx
 **/